import React from 'react'

const Logo = () => {
	return <a className="h-logo" />
}

export default Logo
